const recentlyViewedProducts = {
    cardsContainer: false,
    cardsToShow: 4,

    start: function () {
        this.cardsContainer = document.querySelector('#recently-viewed-products__container');
        if ( ! this.cardsContainer ) {
            return false;
        }
        this.cardsToShow = this.cardsContainer?.dataset?.productsToShow;

        /* Get and output the recently  viewed products */
        let products = recentlyViewedProducts.getProducts();
        recentlyViewedProducts.displayProductCards( products );

        /* Store the currently viewed product into the saved recently viewed products */
        document.addEventListener('DOMContentLoaded', function() {
            const productMain = document.querySelector('section.section-main-product');
            if ( productMain ) {
                const productEl = productMain.querySelector('.product');
                const productID = productEl.dataset.id;
                const productURL = productEl.dataset.url;
                recentlyViewedProducts.addProduct( productID, productURL );
            }
        });
    },

    addProduct: function( productID, productURL ) {
        /* Get recently viewed products array, might be empty */
        let viewedProducts = recentlyViewedProducts.getProducts();
     
        /* Iterate over the recently viewed products, if the product we are on is already in it then remove it */
        viewedProducts.forEach( (product, i) => {
            if ( product?.id === productID ) {
                viewedProducts.splice(i, 1); 
            }
        });

        /* Put our currently viewed product to the front of  the array */
        viewedProducts.unshift({
            id: productID,
            url: window.location.origin + productURL
        })

        /* Limit number of cards stored to cardsToShow + 1 ( needed in case current product was already in ) */
        if ( viewedProducts?.length > this.cardsToShow ) {
            viewedProducts = viewedProducts.slice( 0, this.cardsToShow );
        }

        /* Store the new products array in LocalStorage */
        localStorage.setItem('lfd_recently_viewed_products', JSON.stringify(viewedProducts) );
    },

    getProducts: function() {
        /* Default return an empty array */
        let viewedProducts = [];

        /* If we can find a stored recently viewed products list in localStorage then use that instead */
        let storedProducts = localStorage.getItem('lfd_recently_viewed_products');
        if ( storedProducts ) {
            viewedProducts = JSON.parse(storedProducts);
        }

        return viewedProducts;
    },

    displayProductCards: function( products ) {
        /* If we have recently viewed products then fill the container */
        if ( products?.length ) {
           
            /* We store an extra product in case we need to move the position of the same product, but never want to output that many - so remove the spare one */
            if ( products.length > this.cardsToShow) {
                products.pop();
            } 

            /* Request the product cards */
            const productPromises = products.map( product => {
                return fetch(`${product.url}?view=card`)
                    .then( response => {
                        return response.text();
                    })
                    .then( response => {
                        let dummyEl = document.createElement('div');
                        dummyEl.innerHTML = response;
                        let inner = dummyEl.querySelector('.product-card-wrapper').outerHTML
                        return inner;
                    })
                    .catch( err => console.error(err));
            });
        
            /* Then once they all resolve, output them into the container */
            Promise.all( productPromises )
                .then( productItems => productItems.join(' ') )
                .then( productGridInnerHTML => {
                    this.cardsContainer.innerHTML = `${ productGridInnerHTML }`;
                });
        } 
        /* If we don't have recently viewed products then hide our section as it's useless (this should only ever be the case on first product page load/cookie timeout) */
        else {
            document.querySelector('.recently-viewed-products__outer').remove();
        }
    }
}

recentlyViewedProducts.start();